<input #filePicker type="file" style="display: none" />

<div class="container">
    <div>
        <h1>{{ uploadService.datasetName$ | async }}</h1>
        <div class="multi-upload">
            <input
                type="checkbox"
                id="multi-upload"
                [(ngModel)]="isMultiUploadMode"
                (change)="toggleUploadMode($event)"
            />
            <label for="multi-upload">Multi-upload</label>
            <label class="tooltiptext"> Create datasets for each top-level folder</label>
        </div>
    </div>
    <div>
        <div class="content">
            <div class="panel left">
                <ng-container
                    *ngIf="
                        (uploadService.uploadServiceIsReady$ | async) ?? false;
                        else notReadyBlock
                    "
                >
                    <div class="file-picker">
                        <img src="assets/icons/upload-icon.svg" alt="upload icon" />
                        <div>Drag and drop file here</div>
                        <div>or</div>
                        <cds-button class="button-round" (click)="openFilePicker($event)">
                            Choose file
                        </cds-button>
                    </div>
                </ng-container>

                <ng-template #notReadyBlock>
                    <div class="default-loading-indicator overlay">
                        <cds-progress-circle></cds-progress-circle>
                    </div>
                </ng-template>

                <div #dropZone appFileDropZone class="drop-zone"></div>
            </div>

            <div class="panel right upload-container scroll">
                <ng-container *ngrxLet="uploads$ as uploads">
                    <ng-container *ngIf="!isMultiUploadMode">
                        <ng-container *ngFor="let upload of uploads.current ?? []">
                            <app-upload-file [upload]="upload"></app-upload-file>
                        </ng-container>

                        <ng-container *ngFor="let upload of uploads.completed ?? []">
                            <app-upload-file [upload]="upload"></app-upload-file>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="isMultiUploadMode">
                        <ng-container *ngFor="let upload of uploads.toplevelFile ?? []">
                            <app-upload-file [upload]="upload"></app-upload-file>
                        </ng-container>
                        <ng-container *ngFor="let uploadGroup of uploads.completedGroup ?? []">
                            <div>
                                <div class="upload-group-title">
                                    <cds-icon
                                        shape="file"
                                        [solid]="true"
                                        status="neutral"
                                    ></cds-icon
                                    >{{ uploadGroup.name }}
                                </div>
                                <ng-container *ngFor="let upload of uploadGroup.uploads ?? []">
                                    <app-upload-file [upload]="upload"></app-upload-file>
                                </ng-container>
                            </div>
                        </ng-container>
                    </ng-container>
                </ng-container>
                <ng-container *ngrxLet="uploads$ as uploads">
                    <div
                        class="upload-warning"
                        *ngIf="
                            uploads.current === undefined &&
                            (uploads.completed === undefined || uploads.completed?.length === 0)
                        "
                    >
                        <div>
                            <p>If you’re uploading just <b>one</b> multi-channel image:</p>
                            <ul>
                                <li>Leave the “Multi-upload” checkbox unticked.</li>
                                <li>
                                    Upload all image files that come from the same physical tissue
                                    section (e.g., multiplex IF, H&E) here together.
                                </li>
                                <li>
                                    Channels will be combined from any number of separate files
                                    (e.g., separate files for individual channels, staining cycles,
                                    or imaging modalities).
                                </li>
                            </ul>
                            <p>If you’re uploading <b>more than one</b> multi-channel image:</p>
                            <ul>
                                <li>Tick the "Multi-upload" checkbox.</li>
                                <li>
                                    If you want to combine multiple files into one multi-channel
                                    image (e.g., multiple files for consecutive staining cycles or
                                    different imaging modalities), place them together in a
                                    top-level folder.
                                </li>
                                <li>
                                    If you have single files that contain images of multiple
                                    different physical sections, they will be automatically split
                                    into separate multi-channel images.
                                </li>
                            </ul>
                            <p>General Notes:</p>
                            <ul>
                                <li>
                                    Supported formats include .tif, .tiff, .ome.tiff, .qptiff, .czi,
                                    .ims, .vzg, .mrxs, .nd2, etc.
                                </li>
                                <li>Prefer formats that include metadata.</li>
                                <li>Avoid heavy lossy compression.</li>
                                <li>
                                    Depending on upload size, conversion may take some time --
                                    you'll be notified when it's ready!
                                </li>
                            </ul>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>

    <div class="dataset-controls">
        <cds-button
            *ngrxLet="uploads$ as uploads"
            (click)="submitDataset()"
            [disabled]="(hasCompletedUploads$ | async) === false"
        >
            Submit
        </cds-button>
    </div>
</div>
